"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Message extends Parse.Object {
    constructor(attributes) {
        super('Message', attributes);
    }
    /** The information about the quoted message */
    get quotedMessage() {
        return this.get('quotedMessage');
    }
    set quotedMessage(value) {
        this.set('quotedMessage', value);
    }
    /** Time of update (epoch time in milliseconds) */
    get timestamp() {
        return this.get('timestamp');
    }
    set timestamp(value) {
        this.set('timestamp', value);
    }
    /** Sequence number */
    // get seq(): number { return this.get('seq') }
    // set seq(value: number) { this.set('seq', value) }
    /** Unique external message id */
    get externalId() {
        return this.get('externalId');
    }
    set externalId(value) {
        this.set('externalId', value);
    }
    /** Text of message */
    get text() {
        return this.get('text');
    }
    set text(value) {
        this.set('text', value);
    }
    /** Status of message */
    get status() {
        return this.get('status');
    }
    set status(value) {
        this.set('status', value);
    }
    /** Message sent automatically by omnichat */
    get system() {
        return this.get('system');
    }
    set system(value) {
        this.set('system', value);
    }
    /** Message sent automatically by omnichat */
    get note() {
        return this.get('note');
    }
    set note(value) {
        this.set('note', value);
    }
    /** The chat that message belongs to */
    get chat() {
        return this.get('chat');
    }
    set chat(value) {
        this.set('chat', value);
    }
    /** Type of message */
    get type() {
        return this.get('type');
    }
    set type(value) {
        this.set('type', value);
    }
    /**
     * The message attachment.
     * Only OUTGOING messages have this proporty set
     */
    get attachment() {
        return this.get('attachment');
    }
    set attachment(value) {
        this.set('attachment', value);
    }
    /**
     * The message attachment url
     * Only INCOMING messages have this proporty set
     * For OUTGOING messages use attachment
     */
    get attachmentUrl() {
        return this.get('attachmentUrl');
    }
    set attachmentUrl(value) {
        this.set('attachmentUrl', value);
    }
    /**
     * The message attachment url
     * Only type === LOCATION
     */
    get location() {
        return this.get('location');
    }
    set location(value) {
        this.set('location', value);
    }
    /** The salesperson that sent this message */
    get salesPerson() {
        return this.get('salesPerson');
    }
    set salesPerson(value) {
        this.set('salesPerson', value);
    }
    /** The order related to this message when type === ORDER */
    get order() {
        return this.get('order');
    }
    set order(value) {
        this.set('order', value);
    }
    /** The product related to this message when type === PRODUCT */
    get product() {
        return this.get('product');
    }
    set product(value) {
        this.set('product', value);
    }
    /** The product related to this message when type === COLLECTION */
    get collection() {
        return this.get('collection');
    }
    set collection(value) {
        this.set('collection', value);
    }
    /** The variant related to this message when type === VARIANT */
    get variant() {
        return this.get('variant');
    }
    set variant(value) {
        this.set('variant', value);
    }
    get error() {
        return this.get('error');
    }
    set error(value) {
        this.set('error', value);
    }
    /** If this message is initiating a new conversation/chat */
    get isCreatingNewChat() {
        return this.get('isCreatingNewChat');
    }
    set isCreatingNewChat(value) {
        this.set('isCreatingNewChat', value);
    }
    /**
     * If this message is type ROUTING and is routed to a user.
     * when the chat is picked
     */
    get routedToUser() {
        return this.get('routedToUser');
    }
    set routedToUser(value) {
        this.set('routedToUser', value);
    }
    /** If this message is type ROUTING and is routed to a Team */
    get routedToTeam() {
        return this.get('routedToTeam');
    }
    set routedToTeam(value) {
        this.set('routedToTeam', value);
    }
    get snoozedUntil() {
        return this.get('snoozedUntil');
    }
    set snoozedUntil(value) {
        this.set('snoozedUntil', value);
    }
    // Who has read this message
    get readBy() {
        return this.get('readBy');
    }
    set readBy(value) {
        this.set('readBy', value);
    }
    // if the message should be showed in the UI or not
    get isHidden() {
        return this.get('isHidden');
    }
    set isHidden(value) {
        this.set('isHidden', value);
    }
    /**
     * If the message is based on a existent template.
     */
    get isTemplate() {
        return this.get("isTemplate");
    }
    set isTemplate(value) {
        this.set("isTemplate", value);
    }
    get messageTemplate() {
        return this.get('messageTemplate');
    }
    set messageTemplate(value) {
        this.set('messageTemplate', value);
    }
    get messageTemplateTokens() {
        return this.get('messageTemplateTokens');
    }
    set messageTemplateTokens(value) {
        this.set('messageTemplateTokens', value);
    }
    get internalState() {
        return this.get('internalState');
    }
    set internalState(value) {
        this.set('internalState', value);
    }
    get platform() {
        return this.get('platform');
    }
    set platform(value) {
        this.set('platform', value);
    }
    get externalCampaignId() {
        return this.get('externalCampaignId');
    }
    set externalCampaignId(value) {
        this.set('externalCampaignId', value);
    }
    get campaignTitle() {
        return this.get('campaignTitle');
    }
    set campaignTitle(value) {
        this.set('campaignTitle', value);
    }
    get repliesMessage() {
        return this.get('repliesMessage');
    }
    set repliesMessage(value) {
        this.set('repliesMessage', value);
    }
    /** The retailer this chat belongs to */
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    /** Send the message regardless the chat is with a salesPerson */
    get forceSend() {
        return this.get('forceSend');
    }
    set forceSend(value) {
        this.set('forceSend', value);
    }
    get variantPrice() {
        return this.get('variantPrice');
    }
    set variantPrice(value) {
        this.set('variantPrice', value);
    }
    get origin() {
        return this.get("origin");
    }
    set origin(value) {
        this.set("origin", value);
    }
    // when it is a grouped message, the childs come here
    get groupedMessages() {
        return this.get("groupedMessages");
    }
    set groupedMessages(value) {
        this.set("groupedMessages", value);
    }
    // when it is a grouped message, identifies if it is a child
    get isGrouped() {
        return this.get("isGrouped");
    }
    set isGrouped(value) {
        this.set("isGrouped", value);
    }
    get indexItUntil() {
        return this.get("indexItUntil");
    }
    set indexItUntil(value) {
        this.set("indexItUntil", value);
    }
    get notFinal() {
        return this.get("notFinal");
    }
    set notFinal(value) {
        this.set("notFinal", value);
    }
    get remoteId() {
        return this.get("remoteId");
    }
    set remoteId(value) {
        this.set("remoteId", value);
    }
    get remoteCreatedAt() {
        return this.get("remoteCreatedAt");
    }
    set remoteCreatedAt(value) {
        this.set("remoteCreatedAt", value);
    }
}
exports.Message = Message;
Parse.Object.registerSubclass('Message', Message);
//# sourceMappingURL=Message.js.map